"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-carousel/lib/js/components/Carousel/types.js
// module id = 1279
// module chunks = 0